document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('.dotdigital-signup-form');
  const newsletterContainer = document.querySelector('.newsletter');

  const updateFormUI = () => {
    if (form) {
      const emailLabel = form.querySelector('label[for="dotdigital-for-wordpress_widget_signup_form--1-1email"]');
      if (emailLabel && emailLabel.textContent !== 'Your email: *') {
        emailLabel.textContent = 'Your email: *';
      }
    }

    if (newsletterContainer) {
      newsletterContainer.style.opacity = '1';
    }
  };

  setTimeout(updateFormUI, 100);
});
